import { leaveDate } from '../services/leave-calendar';
import { DateService } from 'src/app/_services/date.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';

import { BaseServices } from './../../kuba.services';
import { EmployeeLeaveService } from './../services/employeeleave.service';
import { HelperService, PdfSetting } from './../../../_services/helper.service';
import { EmployeeLeaveAvailability, EmployeeHoliday } from '../models/index';

import { ValidationService } from 'src/app/kuba/shared/services/validation.service';

import { TranslateService } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';

@Component({
  selector: 'leave-allocate',
  templateUrl: 'employee-leaveallocate.component.html',
  styleUrls: ['employee-leaveallocate.component.scss'],
  standalone: false
})
export class LeaveAllocateComponent implements OnInit {
  @ViewChild('leavesAllocateTable', { static: false })
  leavesAllocateTable: Table;
  @ViewChild('hoildayTable', { static: false }) hoildayTable: Table;
  private readonly notifications = inject(NotificationService);
  isAddType = false;
  viewType: boolean;
  leaveAllocateForm: FormGroup;
  leaveavalible: string;
  holidayId: number;
  businessId: number;
  holidayForm: FormGroup;
  yearDropdown: SelectItem[] = [];
  leaves: any = [];
  holidays: any = [];
  type: any = [];
  location: Location;
  selectedLeaves: any = [];
  CurrentYear: any;
  additionalData: any;
  holidaysList: any = [];
  allocateApply: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    public employeeLeaveService: EmployeeLeaveService,
    public confirmationService: ConfirmationService,
    private translate: TranslateService,
    private dateService: DateService
  ) {
    this.businessId = BaseServices.BusinessId;
    this.leaveAllocateForm = this.fb.group({
      Year: ['', Validators.required],
      LeaveAvailable: ['0']
    });

    this.holidayForm = this.fb.group({
      HolidayDate: ['', [Validators.required]],
      HolidayName: [
        '',
        [Validators.required, ValidationService.noWhitespaceValidator]
      ]
    });
    this.yearDropdown = [];
    this.bindYearDropdown();

    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.EMPLOYEE_LEAVE_DETAILS,
          header: 'Employee Leave Details',
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Employee Name', dataKey: 'Name' },
            { title: 'Availed Days', dataKey: 'LeaveAvailable' },
            { title: 'Days Allocated', dataKey: 'DaysUsed' },
            { title: 'Days Left', dataKey: 'DaysLeft' }
          ]
        };
      })
    );
  }

  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.bindHolidays();
    let year = new Date();
    this.CurrentYear = year.getFullYear();
    this.leaveAllocateForm.controls['Year'].setValue(this.CurrentYear, {
      onlySelf: true
    });
    this.bindLeavesAvaliable(this.CurrentYear);
  }

  /**
   * Bind year dropdown, shows last 5 years to next 1 year
   */
  bindYearDropdown() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 5; i <= currentYear + 1; i++) {
      this.yearDropdown.push({
        label: i.toString(),
        value: i
      });
    }
  }

  bindLeavesAvaliable(year: number) {
    this.leaves = [];
    if (year == null) {
      this.subscriptions.push(
        this.employeeLeaveService
          .getAllLeaveAllocation(this.businessId, 0)
          .subscribe(res => {
            this.leaves = res;
          })
      );
    } else {
      this.subscriptions.push(
        this.employeeLeaveService
          .getAllLeaveAllocation(this.businessId, year)
          .subscribe(res => {
            this.leaves = res;
          })
      );
    }
    this.selectedLeaves = [];
  }

  bindHolidays() {
    this.holidays = [];
    this.holidaysList = [];
    let year;
    let month;
    let day;
    this.subscriptions.push(
      this.employeeLeaveService
        .getAllHolidays(BaseServices.BusinessId)
        .subscribe(res => {
          this.holidays = res;

          // Sort the holidays array by HolidayDate in descending order
          this.holidays.sort((a: any, b: any) => {
            return (
              new Date(b.HolidayDate).getTime() -
              new Date(a.HolidayDate).getTime()
            );
          });

          for (let i = 0; i < this.holidays.length; i++) {
            if (this.holidays[i].HolidayDate) {
              year = new Date(this.holidays[i].HolidayDate).getUTCFullYear();
              month = new Date(this.holidays[i].HolidayDate).getMonth() + 1;
              day = new Date(this.holidays[i].HolidayDate).getDate();
            }
            this.holidaysList.push({
              year: year,
              month: month,
              day: day
            });
          }
        })
    );
  }

  editHoliday(employeeType: any) {
    this.holidayId = employeeType.Id;
    this.holidayForm.patchValue({
      HolidayDate: leaveDate(employeeType.HolidayDate),
      HolidayName: employeeType.HolidayName
    });
  }

  deleteHoliday(id: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.employeeLeaveService
            .deleteHoliday(id)
            .subscribe(isHolidayDeleted => {
              if (isHolidayDeleted) {
                this.bindHolidays();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              }
            })
        );
      }
    });
  }

  saveHoliday() {
    let employeeType = new EmployeeHoliday();
    employeeType.Id = this.holidayId ? this.holidayId : 0;
    employeeType.HolidayName = this.holidayForm.value.HolidayName;
    const date = leaveDate(this.holidayForm.value.HolidayDate);
    this.holidayForm.markAllAsTouched();
    if (this.holidayForm.invalid || date === null) return;
    employeeType.HolidayDate = this.dateService.formatDateToString(date);
    employeeType.Status = '1';
    employeeType.BusinessId = BaseServices.BusinessId;
    if (employeeType.Id > 0) {
      this.subscriptions.push(
        this.employeeLeaveService
          .updateHoliday(employeeType)
          .subscribe(updateResponse => {
            if (updateResponse) {
              this.bindHolidays();
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.viewType = true;
              this.holidayForm.reset();
              this.holidayId = 0;
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.employeeLeaveService
          .createHoliday(employeeType)
          .subscribe(addResponse => {
            if (addResponse) {
              this.bindHolidays();
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.viewType = true;
              this.holidayForm.reset();
              this.holidayId = 0;
            }
          })
      );
    }
  }

  saveMultiple() {
    const year = Number(this.leaveAllocateForm.value.Year);
    const days = Number(this.leaveAllocateForm.value.LeaveAvailable);
    this.leaveAllocateForm.markAllAsTouched();
    if (
      this.leaveAllocateForm.invalid ||
      !Number.isInteger(year) ||
      year < 1753 ||
      year > 9999 ||
      !Number.isInteger(days) ||
      days < 0
    )
      return;
    let leaves: EmployeeLeaveAvailability[] = [];

    if (this.selectedLeaves.length !== 0) {
      this.selectedLeaves.forEach((employeeLeave: any) => {
        if (employeeLeave) {
          let employee = new EmployeeLeaveAvailability();
          employee.Id = employeeLeave.id ?? employeeLeave.Id ?? 0;
          employee.BusinessId = BaseServices.BusinessId;
          employee.Name = employeeLeave.Name;
          employee.EmployeeId = employeeLeave.EmployeeId;
          employee.Year = year;
          employee.LeaveAvailable = days;

          leaves.push(employee);
        }
      });
      this.subscriptions.push(
        this.employeeLeaveService.saveLeaveAllocation(leaves).subscribe(() => {
          this.bindLeavesAvaliable(this.leaveAllocateForm.value.Year);
          this.notifications.success('UI_NOTIFICATIONS.SAVED');
          // Reset the LeaveAvailable field
          this.leaveAllocateForm.controls['LeaveAvailable'].reset();
        })
      );
    } else {
      this.notifications.warn(
        'PLEASE_SELECT_ATLEAST_ONE_EMPLOYEE_TO_DO_THIS_OPERATION'
      );
    }
  }

  exportPdf() {
    let pdfSetting = new PdfSetting();
    pdfSetting.date = 'Date:' + HelperService.formatDate(new Date());
    pdfSetting.businessName = BaseServices.BusinessName;
    pdfSetting.pageHeader = 'Leave';
    let data = this.leaves;
    this.subscriptions.push(
      this.translate.stream('ALLOCATE_LEAVE_DAYS').subscribe(val => {
        let columns = [
          { title: val.EMPLOYEE_NAME, dataKey: 'Name' },
          { title: val.AVAILED_DAYS, dataKey: 'LeaveAvailable' },
          { title: val.DAYS_ALLOCATED, dataKey: 'DaysUsed' },
          { title: val.DAYS_LEFT, dataKey: 'DaysLeft' }
        ];
        HelperService.generatePdf(
          data,
          columns,
          'Employee Leave Details',
          pdfSetting,
          'l'
        );
      })
    );
  }

  onBeforeHolidayDialogHide() {
    this.holidayForm.reset();
  }

  onNumberChange(e: any, limitNumber: any) {
    HelperService.numberFieldValidation(e, limitNumber);
    if (e.key == 0 || e.key > 0) {
      this.allocateApply = false;
    } else {
      this.allocateApply = true;
    }
  }

  onLeaveAvailableChange(event: any) {
    const leaveAvailable = parseInt(event.target.value, 10);

    if (!isNaN(leaveAvailable)) {
      this.selectedLeaves.forEach((selectedLeave: any) => {
        const leave = this.leaves.find(
          (l: any) => l.EmployeeId === selectedLeave.EmployeeId
        );
        if (leave) {
          leave.LeaveAvailableDisplay = `${leave.LeaveAvailable} <span>(${leaveAvailable})</span>`;
        }
      });
    } else {
      this.leaves.forEach((leave: any) => {
        leave.LeaveAvailableDisplay = leave.LeaveAvailable;
      });
    }
  }

  onSelectionChange(event: any) {
    const leaveAvailable = parseInt(
      this.leaveAllocateForm.get('LeaveAvailable')?.value,
      10
    );

    this.leaves.forEach((leave: any) => {
      if (
        this.selectedLeaves.some(
          (selectedLeave: any) => selectedLeave.EmployeeId === leave.EmployeeId
        )
      ) {
        if (!isNaN(leaveAvailable)) {
          leave.LeaveAvailableDisplay = `${leave.LeaveAvailable} <span>(${leaveAvailable})</span>`;
        }
      } else {
        leave.LeaveAvailableDisplay = leave.LeaveAvailable;
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
